module.exports = __webpack_public_path__ + "img/26.32220f37.jpg";